
const Footer = () => {
  return <footer>
    <p>
      SaO Systém 2023
    </p>
  </footer>
}
export default Footer